import React, { useState, useCallback } from "react";
import { useWorkflowExecution } from "../../../../context/WorkflowExecutionContext";
import { useWorkflow } from "../../../../context/WorkflowContext";
import DataViewer from "./DataViewer";

export default function InputTab({ step }) {
    const { steps, testData, setTestData } = useWorkflow();
    const { stepExecutionResult } = useWorkflowExecution();
    const [isEditing, setIsEditing] = useState(false);
    const [editJson, setEditJson] = useState("");

    const stepIndex = steps.findIndex((s) => s.id === step.id);
    const prevStepIndex = stepIndex > 0 ? stepIndex - 1 : -1;

    let inputData = null;
    let source = "none";
    const prevStepName = prevStepIndex >= 0 ? steps[prevStepIndex]?.name : "Trigger";

    if (stepExecutionResult && prevStepIndex >= 0 && stepExecutionResult[prevStepIndex]) {
        const prevResult = stepExecutionResult[prevStepIndex];
        inputData = prevResult?.output || prevResult?.result || prevResult;
        source = "step";
    } else if (testData) {
        inputData = testData;
        source = stepIndex === 0 ? "trigger" : "testData";
    }

    const handleEditTestData = useCallback(() => {
        setEditJson(inputData ? JSON.stringify(inputData, null, 2) : "{\n  \n}");
        setIsEditing(true);
    }, [inputData]);

    const handleSaveTestData = useCallback(() => {
        try {
            const parsed = JSON.parse(editJson);
            setTestData(parsed);
            setIsEditing(false);
        } catch {
            /* invalid JSON, don't save */
        }
    }, [editJson, setTestData]);

    const itemCount = Array.isArray(inputData) ? inputData.length : inputData ? 1 : null;

    return (
        <div className="flex flex-col h-full">
            {isEditing ? (
                <div className="flex flex-col h-full">
                    <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
                        <span className="text-xs text-gray-500 font-medium">Edit test data</span>
                        <div className="flex gap-1">
                            <button onClick={() => setIsEditing(false)} className="px-2 py-1 text-xs text-gray-500 hover:text-gray-700">Cancel</button>
                            <button onClick={handleSaveTestData} className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700">Save</button>
                        </div>
                    </div>
                    <textarea
                        className="flex-1 p-4 text-xs font-mono resize-none border-0 focus:outline-none"
                        value={editJson}
                        onChange={(e) => setEditJson(e.target.value)}
                    />
                </div>
            ) : (
                <>
                    <DataViewer data={inputData} label="input data" itemCount={itemCount} />
                    <div className="flex items-center justify-between px-4 py-2 border-t border-gray-200 bg-gray-50">
                        {inputData && (
                            <span className="text-[10px] text-gray-400">
                                {source === "step" ? `From "${prevStepName}"` : source === "trigger" ? "From trigger" : "Pinned test data"}
                            </span>
                        )}
                        <div className="flex gap-2 ml-auto">
                            {inputData && source === "step" && (
                                <button onClick={() => setTestData(inputData)} className="text-xs text-gray-500 hover:text-blue-600">Pin data</button>
                            )}
                            {source === "testData" && (
                                <button onClick={() => setTestData(null)} className="text-xs text-gray-500 hover:text-red-500">Unpin</button>
                            )}
                            <button onClick={handleEditTestData} className="text-xs text-gray-500 hover:text-blue-600">Edit test data</button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
